const collapseSelectors = [
    '.target-collapse',
    '.img-transcription',
    '.collapse-box'
];
const collapseWrapperPrototype = '<div class="collapse-wrapper"></div>';
const collapseContentWrapperPrototype = '<div class="collapse" id="collapsible-ID_NUM" aria-labelledby="collapse-toggler-ID_NUM"></div>';
const collapsePillPrototype = '<i class="collapse-pill"></i>';

export default function initCollapse() {
    function initCollapseToggler($toggler, index) {
        var $anchor = $('<a/>');
        $anchor.attr({
            'data-toggle': "collapse",
            'href': "#collapsible-"+index,
            'aria-expanded': false,
            'aria-controls': "#collapsible-"+index,
            'class':'collapse-primary',
            'role': "button",
            'id': "collapse-toggler-"+index
        });

        $toggler.replaceWith($anchor);
        $anchor.append($toggler);

        // if(!$toggler.hasClass('heading-collapsible')) {
        //     $anchor.prepend($(collapsePillPrototype));
        // } else {
        //     return $anchor;
        // }

    }
    function prepareWrapperPrototype(index) {
        let preparedPrototype = collapseContentWrapperPrototype.replace(/ID_NUM/g, index);
        return $(preparedPrototype);
    }

    // allows each collapse element to have a unique ID
    let masterIndex = 0;

    // cycle through all possible collapse selectors
    collapseSelectors.forEach(function(selector) {
        
        // find elements in DOM
        let $collapsables = $(selector);

        // process each of them
        $collapsables.each(function(i, collapsable) {
            // prepare wrapper with index
            let $wrapper = $(prepareWrapperPrototype(masterIndex));

            // cycle through children to find first element (toggler) and rest is wrapped inside collapse
            $(this).children().each(function(childIndex, element) {
                if (childIndex == 0) {
                    initCollapseToggler($(this), masterIndex);
                } else {
                    if(selector == '.collapse-box') {
                        $wrapper.append($('<div class="card card-body"></div>').append($(this)));
                    }
                    if(selector == '.img-transcription') {
                        $wrapper.append($('<div class="card card-body"></div>').append($(this)));
                        const $img = $(collapsable).prev().find('img');

                        if ($img.length) {
                            $(collapsable).prev().addClass('image');
                            $img.attr('aria-describedby',$wrapper.attr('id'));
                        }                        
                    }
                }
            });

            $(this).append($wrapper);
            $(this).collapse('hide');
            masterIndex++;
        });
    });
}